import { clone } from 'remeda';

import { type Tenant } from '@@api/services/tenant/schemas';
import { type LocalVariants } from '@@api/utils/schemas/utils';
import { DEFAULT_TENANT_ID } from '@@containers/metadata/constants';

// @ts-expect-error TS7006 Issue #4120
export const getVariantById = (variants, id) =>
    // @ts-expect-error TS7006 Issue #4120
    variants.find((variant) => variant.variantId === id);
// @ts-expect-error TS7006 Issue #4120
export const getVariantIndexById = <Variants extends LocalVariants>(variants: Variants, id) =>
    variants.findIndex((variant) => variant.variantId === id);
// @ts-expect-error TS7006 Issue #4120
export const getDefaultVariant = (variants) =>
    // @ts-expect-error TS7006 Issue #4120
    variants.find((variant) => variant.variantId === DEFAULT_TENANT_ID);

const makeNewVariants = (
    tenantIds: Tenant['id'][],
    tenantVariants: LocalVariants,
    sourceTenantId: Tenant['id'],
) => {
    const sourceTenantVariant = getVariantById(tenantVariants, sourceTenantId);

    return tenantIds.map((tenantId) => ({ ...sourceTenantVariant, variantId: tenantId }));
};

export const addVariants = (
    tenantIds: Tenant['id'][],
    tenantVariants: LocalVariants,
    sourceTenantId: Tenant['id'],
) => {
    const newTenantVariantsWithDefaults = makeNewVariants(
        tenantIds,
        tenantVariants,
        sourceTenantId,
    );

    return newTenantVariantsWithDefaults.reduce((result, newTenantVariant) => {
        const index = getVariantIndexById(result, newTenantVariant.variantId);

        if (index === -1) {
            // Only append the new variant if it does not yet exist in order to avoid duplicate variants
            result.push(newTenantVariant);
        }

        return result;
    }, clone(tenantVariants));
};

// Issue #4120
// oxlint-disable-next-line typescript/no-explicit-any
export const removeVariants = (tenantIds: Tenant['id'][], tenantVariants: any) =>
    // @ts-expect-error TS7031 Issue #4120
    tenantVariants.filter(({ variantId }) => !tenantIds.includes(variantId));

export const copyVariants = (
    tenantIds: Tenant['id'][],
    tenantVariants: LocalVariants,
    sourceTenantId: Tenant['id'],
) => {
    const newTenantVariantsWithDefaults = makeNewVariants(
        tenantIds,
        tenantVariants,
        sourceTenantId,
    );

    return newTenantVariantsWithDefaults.reduce((result, newTenantVariant) => {
        const index = getVariantIndexById(result, newTenantVariant.variantId);

        if (index >= 0) {
            // If the variant already exist, overwrite it in order to avoid duplicate variants
            result.splice(index, 1, newTenantVariant);
        } else {
            // Otherwise just append it
            result.push(newTenantVariant);
        }

        return result;
    }, clone(tenantVariants));
};
